export class DisplayDirectAlertSettings {
    key: string;
    bivPacingDropdowns: string;
    clinicDefaults: ExportOptionsModel[];
    customerApplicationId: number;
    customerApplicationPatientId: number;
    deviceCategoryCd: number;
    deviceProductId: number;
    durationCdOptions: SeverityOptionModel[];
    lssaCapable: boolean;
    patientId: number;
    patientOverrides: ExportOptionsModel[];
    rvPacingDropdowns: string;
    severityOptions: SeverityOptionModel[];
    patientRecordSymptomTxFlg?: boolean;
}

export class DisplayGroupList {
    groupInfo: GroupInfo[];
}

export class GroupInfo {
    displayGroupCategoryCd: number;
    displayName: string;
    groupInfo: ExportOptionsModel[] = [];
}

export class DisplayAlertNotificationModel {
    patientId: number;
    customerApplicationId: number;
    customerApplicationPatientId: number;
    deviceCategoryCd: number;
    deviceProductId: number;
    lssaCapable: boolean;
    clinicDefaults: ExportOptionsModel[];
    patientOverrides: ExportOptionsModel[];
    severityOptions: SeverityOptionModel[];
    durationCdOptions: SeverityOptionModel[];
    displayGroupCategoryCdOptions: SeverityOptionModel[];
    rvPacingDropdowns: number[];
    bivPacingDropdowns: number[];
    clinicRecordSymptomTxFlg: boolean;
    patientRecordSymptomTxFlg: boolean;
}

export class SeverityOptionModel {
    code: string;
    codeId: number;
    description: string;
    qualifier: string;
}

export class ExportOptionsModel {
    alertCode: number;
    alertGroupId: number;
    alertHandlingId: number;
    alertSubCategoryCd: number;
    alertSubCategoryHeaderCd: string;
    displayFlg: boolean;
    durationCd: string;
    defaultSeverityCd: number;
    severityCd: number;
    threshold: string;
    alertDesc: string;
    displayGroupCategoryCd: number;
    defaultDisplayFlg?: any;
    overrideDisplayFlg?: any;
    oldDisplayFlg?: any;
    oldSeverityCd?: any;
    doNotDisplayCongestionMonitoring?: any;
    notifyPatientUiInactiveFlg?: boolean
}
